<div id="datePickersCont" style="display: flex !important;">
  <div class="timePicker">
    <div class="timeTextStart">
      {{"FROM"|translate}}:
    </div>
    <ngb-timepicker [(ngModel)]="startTimePicker" [seconds]="true" [meridian]="false"></ngb-timepicker>
  </div>
  <div class="timePicker">
    <div class="timeTextEnd">
      {{"TO"|translate}}:
    </div>
      <ngb-timepicker [(ngModel)]="endTimePicker" [seconds]="true" [meridian]="false"></ngb-timepicker>
  </div>
  <div class="btnsubmit">
    <button type="button" class="btn btn-datepicker" style="background: green"
            (click)="submit()"
            [ngbTooltip]="'SUBMIT'|translate">
      <fa-icon [icon]="faCheck"></fa-icon>
    </button>
  </div>
</div>
